import moment from 'moment'
import React from 'react'

import { EuiFlexGroup, EuiFlexItem, EuiProgress } from '@elastic/eui'

import { BudgetFrequency, Campaign } from 'api/interfaces'
import { formatPercentage } from 'utils/Formatters'

interface CampaignProgressProps {
  campaign: Campaign
  size?: 's' | 'm' | 'l'
  color?: string
}

export const CampaignProgress: React.FC<CampaignProgressProps> = ({
  campaign,
  size = 's',
  color = 'success'
}) => {
  if (campaign.budgetFrequency !== BudgetFrequency.Total) {
    return <span>{campaign.budgetFrequency.toLowerCase()}</span>
  }

  const startDate = moment(campaign.startDate).startOf('day')
  const endDate = campaign.endDate ? moment(campaign.endDate).startOf('day') : moment().startOf('day')
  const totalDays = endDate.diff(startDate, 'days') + 1
  const today = moment().startOf('day')
  let daysPassed = Math.max(0, today.diff(startDate, 'days') + 1)
  daysPassed = Math.min(daysPassed, totalDays)

  if (totalDays <= 0) {
    return <span>No timeline</span>
  }

  let progress = Math.min(100, (daysPassed / totalDays) * 100)
  progress = Math.max(0, progress)

  return (
    <EuiFlexGroup title={`${formatPercentage(progress / 100, 0, 0)}`}>
      <EuiFlexItem>
        <EuiProgress value={progress} max={100} size={size} color={color} />
      </EuiFlexItem>
    </EuiFlexGroup>
  )
}
